import Icon from '../components/Icon.vue'

Icon.register({"percentage":{"width":384,"height":512,"paths":[{"d":"M109.3 173.3C134.2 148.3 134.2 107.7 109.3 82.7 84.3 57.8 43.7 57.8 18.7 82.7-6.3 107.7-6.3 148.3 18.7 173.3 43.7 198.3 84.3 198.3 109.3 173.3zM365.3 338.7C340.3 313.8 299.7 313.8 274.7 338.7 249.8 363.7 249.8 404.3 274.7 429.3 299.7 454.2 340.3 454.2 365.3 429.3 390.3 404.3 390.3 363.7 365.3 338.7zM363.3 107.3L340.7 84.7C328.2 72.2 307.9 72.2 295.4 84.7L20.7 359.4C8.2 371.9 8.2 392.2 20.7 404.7L43.3 427.3C55.8 439.8 76.1 439.8 88.6 427.3L363.3 152.6C375.8 140.1 375.8 119.8 363.3 107.3z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/percentage.js
// module id = null
// module chunks = 